import "https://unpkg.com/@tailwindcss/browser@4";

import { Routes, Route } from "react-router-dom";
import Dashboard from "./pages/Dashboard";
import AppStatus from "./pages/AppStatus";
import Remarks from "./pages/Remarks";
import RemarkDetail from "./pages/RemarkDetail";
import Setttings from "./pages/Settings";
import ManagerDashboard from "./pages/manager/ManagerDashboard";
import CompanyProfile from "./pages/manager/CompanyProfile";
import AssignForms from "./pages/AssignForms";
import UnassignedCompanies from "./pages/UnassignedCompanies";
import Form from "./pages/Form";
import Login from "./pages/auth/Login";
import { PrivateRoute } from "./components/PrivateRoute";
import { AuthProvider } from "./context/AuthContext";
import { useAuth } from "./context/AuthContext";
import Unauthorized from "./pages/auth/Unauthorized";
import Companies from "./pages/Companies";
import ValidatorsPage from "./pages/Validators";
import AdminLayout from "./layouts/AdminLayout";
import ChangeManagerPassword from "./pages/auth/ChangeManagerPassword";
import ValidatorsSettings from "./pages/validators/Settings";
import ValidatorList from "./pages/validators/List";
import Register from "./pages/auth/Register";
import Loading from "./components/Loading";
import Profile from "./pages/validators/Profile";
import UserLayout from "./layouts/UserLayout";
import Submissions from "./pages/manager/submissions";
import { ToastProvider } from "./context/ToastContext";

const AppRoutes = () => {
  const { loading } = useAuth();

  if (loading) return <Loading fullscreen={true} />;

  return (
    <>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/unauthorized" element={<Unauthorized />} />
        <Route
          path="/"
          element={
            <PrivateRoute allowedRoles={["validator", "manager", "superadmin"]}>
              <UserLayout>
                <Dashboard />
              </UserLayout>
            </PrivateRoute>
          }
        />
        <Route
          path="/form"
          element={
            <PrivateRoute allowedRoles={["validator"]}>
              <UserLayout>
                <Form />
              </UserLayout>
            </PrivateRoute>
          }
        />
        <Route
          path="/review-form"
          element={
            <PrivateRoute allowedRoles={["manager", "superadmin"]}>
              <AdminLayout>
                <Form />
              </AdminLayout>
            </PrivateRoute>
          }
        />
        <Route
          path="/change-password"
          element={
            <PrivateRoute allowedRoles={["validator"]}>
              <UserLayout>
                <ChangeManagerPassword />
              </UserLayout>
            </PrivateRoute>
          }
        />
        <Route
          path="/change-password"
          element={
            <PrivateRoute allowedRoles={["manager", "superadmin"]}>
              <AdminLayout>
                <ChangeManagerPassword />
              </AdminLayout>
            </PrivateRoute>
          }
        />
        <Route
          path="/approved"
          element={
            <PrivateRoute>
              <AppStatus status="approved" />
            </PrivateRoute>
          }
        />
        <Route
          path="/pending"
          element={
            <PrivateRoute>
              <AppStatus status="pending" />
            </PrivateRoute>
          }
        />
        <Route
          path="/rejected"
          element={
            <PrivateRoute>
              <AppStatus status="rejected" />
            </PrivateRoute>
          }
        />
        <Route
          path="/remarks"
          element={
            <PrivateRoute>
              <Remarks />
            </PrivateRoute>
          }
        />
        <Route
          path="/remarks/id"
          element={
            <PrivateRoute>
              <RemarkDetail id={1} />
            </PrivateRoute>
          }
        />
        <Route
          path="/submissions"
          element={
            <PrivateRoute allowedRoles={["manager", "superadmin"]}>
              <AdminLayout>
                <Submissions />
              </AdminLayout>
            </PrivateRoute>
          }
        />
        <Route
          path="/settings"
          element={
            <PrivateRoute allowedRoles={["manager", "superadmin"]}>
              <AdminLayout>
                <Setttings />
              </AdminLayout>
            </PrivateRoute>
          }
        />
        <Route
          path="/manager-dashboard"
          element={
            <PrivateRoute allowedRoles={["manager", "superadmin"]}>
              <AdminLayout>
                <ManagerDashboard />
              </AdminLayout>
            </PrivateRoute>
          }
        />
        <Route
          path="/company-profile"
          element={
            <PrivateRoute allowedRoles={["manager", "superadmin"]}>
              <AdminLayout>
                <CompanyProfile />
              </AdminLayout>
            </PrivateRoute>
          }
        />
        <Route
          path="/companies"
          element={
            <PrivateRoute allowedRoles={["manager", "superadmin"]}>
              <AdminLayout>
                <Companies />
              </AdminLayout>
            </PrivateRoute>
          }
        />
        <Route
          path="/assign-forms"
          element={
            <PrivateRoute allowedRoles={["manager", "superadmin"]}>
              <AdminLayout>
                <AssignForms />
              </AdminLayout>
            </PrivateRoute>
          }
        />
        <Route
          path="/unassigned-companies"
          element={
            <PrivateRoute allowedRoles={["manager", "superadmin"]}>
              <AdminLayout>
                <UnassignedCompanies />
              </AdminLayout>
            </PrivateRoute>
          }
        />
        <Route
          path="/validators"
          element={
            <PrivateRoute allowedRoles={["manager", "superadmin"]}>
              <AdminLayout>
                <ValidatorsPage />
              </AdminLayout>
            </PrivateRoute>
          }
        />
        <Route
          path="/change-manager-password"
          element={
            <PrivateRoute allowedRoles={["manager", "superadmin"]}>
              <AdminLayout>
                <ChangeManagerPassword />
              </AdminLayout>
            </PrivateRoute>
          }
        />
        <Route
          path="/validators/settings"
          element={
            <PrivateRoute allowedRoles={["manager", "superadmin"]}>
              <AdminLayout>
                <ValidatorsSettings type="all" />
              </AdminLayout>
            </PrivateRoute>
          }
        />
        <Route
          path="/validators/change-password-list"
          element={
            <PrivateRoute allowedRoles={["manager", "superadmin"]}>
              <AdminLayout>
                <ValidatorList type="change" />
              </AdminLayout>
            </PrivateRoute>
          }
        />

        <Route
          path="/validators/remove-list"
          element={
            <PrivateRoute allowedRoles={["manager", "superadmin"]}>
              <AdminLayout>
                <ValidatorList type="remove" />
              </AdminLayout>
            </PrivateRoute>
          }
        />
        <Route
          path="/validators/change-validator-password"
          element={
            <PrivateRoute allowedRoles={["manager", "superadmin"]}>
              <AdminLayout>
                <ChangeManagerPassword />
              </AdminLayout>
            </PrivateRoute>
          }
        />
        <Route
          path="/validators/add"
          element={
            <PrivateRoute allowedRoles={["manager", "superadmin"]}>
              <AdminLayout>
                <Register />
              </AdminLayout>
            </PrivateRoute>
          }
        />
        <Route
          path="/validators/profile"
          element={
            <PrivateRoute allowedRoles={["manager", "superadmin"]}>
              <AdminLayout>
                <Profile />
              </AdminLayout>
            </PrivateRoute>
          }
        />
      </Routes>
    </>
  );
};

const App = () => (
  <AuthProvider>
    <ToastProvider>
      <AppRoutes />
    </ToastProvider>
  </AuthProvider>
);

export default App;
